import React, { Component } from 'react';
import Product from './product.js';
//import Breadcrumbs from './breadcrumbs.js';

class Productlist extends Component {

    render() {

        let config = this.props.config;
        let path = this.props.path;
        //let auth = this.props.auth;
        //let currentCategory = config.categories.find(h => h.path === path.substring(1));
        let currentCategory = config.categories.find(h => h.path === path.split('/').slice(-1)[0]);

        //let products = currentCategory.products;
        let products = currentCategory.products.filter(p => !p.hidden || p.hidden !== true );

        let messageClass = '';
        if (currentCategory.filters.length > 0) {
            messageClass = 'search-message-row';
        }
        else {
            messageClass = 'search-message-row hidden';
        }

        return (

            <div className="products">
                {products.map(function (product, i) {
                    return <Product product={product} category={currentCategory} key={i} />;
                })}

                <div className={messageClass} id="searchMessageRow">
                    <div className="search-message">
                        <div className="search-message-icon">
                            <img src={`${process.env.REACT_APP_PUBLIC_URL}/assets/ui/search-asset-icon.svg`} alt="search asset" />
                        </div>
                        <div className="search-message-text">
                            Start your search using the filters above.
                                </div>
                    </div>
                </div>
            </div>


        )
    }
}

export default Productlist;
